// @flow
import { createSelector } from 'reselect'
import { selectCalendarState } from './selector-common'
import type { Selector } from 'types/state'
import type { ColorsState } from './types-colors'
import type { CalendarState } from './types'

export const getCalendarColors = (): Selector<ColorsState> =>
  createSelector(selectCalendarState, (state: CalendarState) => state.colors)
